import { Box } from "@mui/material";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import AuthTransition from "@/components/auth/AuthTransition";
import { LoadingState } from "@/components/common/LoadingState";

interface SignInPanelProps extends PropsWithChildren {
  title?: string;
  description?: string;
  loading?: boolean;
  onLoadingEntered?: () => void;
}

export default function SignInPanel({
  children,
  title,
  description,
  loading = false,
  onLoadingEntered,
}: SignInPanelProps) {
  const { t } = useTranslation();

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="text-center mb-8">
        <Box
          component="h1"
          className="font-bold bg-gradient-to-r from-[#0066ff] to-[#00B7FF] bg-clip-text text-transparent mb-2"
          sx={{ fontSize: { xs: "1.875rem", sm: "2.25rem" } }}
        >
          {title ?? t("login.title")}
        </Box>
        <p className="text-gray-600 text-lg">{description ?? t("login.text.signAccount")}</p>
      </div>
      <AuthTransition in={!loading}>
        <div inert={loading} aria-hidden={loading}>
          {children}
        </div>
      </AuthTransition>
      <AuthTransition in={loading} onEntered={onLoadingEntered}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: { xs: 6, sm: 8 },
            textAlign: "center",
          }}
        >
          <LoadingState label={t("login.loading")} />
        </Box>
      </AuthTransition>
    </div>
  );
}
